import { Module } from 'vuex'
export interface TabItem {
  path: string
  meta: {
    title: string
    [key: string]: any
  }
}

export interface TabsState {
  visitedViews: TabItem[]
  activeTab: string
}

const tabsModule: Module<TabsState, any> = {
  namespaced: true,
  
  state: (): TabsState => {
    // 从 sessionStorage 加载状态
    try {
      const cachedTabs = sessionStorage.getItem('tabs')
      if (cachedTabs) {
        const parsedTabs = JSON.parse(cachedTabs)
        if (parsedTabs && parsedTabs.visitedViews) {
          return {
            visitedViews: parsedTabs.visitedViews,
            activeTab: parsedTabs.activeTab || ''
          }
        }
      }
    } catch (e) {
      console.error('Failed to load tabs from sessionStorage', e)
    }
    
    // 默认状态
    return {
      visitedViews: [
        {
          path: '/Home',
          meta: { title: '首页' }
        }
      ],
      activeTab: ''
    }
  },
  
  mutations: {
    ADD_TAB(state, route: { path: string, meta: any }): void {
      const { path, meta } = route
      if (state.visitedViews.some(v => v.path === path)) return
      state.visitedViews.push({
        path,
        meta
      })
    },
    
    REMOVE_TAB(state, targetPath: string): void {
      state.visitedViews = state.visitedViews.filter(tab => tab.path !== targetPath)
    },
    
    SET_ACTIVE_TAB(state, path: string): void {
      state.activeTab = path
    },
  // 完全重置标签页（包括首页）
  RESET_TABS(state) {
    state.visitedViews = [];
    state.activeTab = '';
  }
  },
  
  actions: {
    addTab({ commit }, route: { path: string, meta: any }): void {
      commit('ADD_TAB', route)
    },
    
    removeTab({ commit, state }, targetPath: string): string {
      let activePath = state.activeTab
      if (activePath === targetPath) {
        state.visitedViews.forEach((tab, index) => {
          if (tab.path === targetPath) {
            const nextTab = state.visitedViews[index + 1] || state.visitedViews[index - 1]
            if (nextTab) {
              activePath = nextTab.path
            }
          }
        })
      }
      commit('REMOVE_TAB', targetPath)
      return activePath
    },
    
    setActiveTab({ commit }, path: string): void {
      commit('SET_ACTIVE_TAB', path)
    },
    resetTabs({ commit }) {
      commit('RESET_TABS');
      // return '/login'; // 登出时跳转到登录页
    }
  },
  
  getters: {
    getVisitedViews: (state: TabsState) => state.visitedViews,
    getActiveTab: (state: TabsState) => state.activeTab
  }
}

export default tabsModule